var ACC                = ACC || {};
ACC.autocomplete       = ACC.autocomplete || {};

ACC.autocomplete.bindAll = function () {
	this.bindSearchAutocomplete();
	this.bindMagnifyingGlass();
};

ACC.autocomplete.bindSearchAutocomplete = function () {
    var $search = $(".js-search-form-input");
	var option  = $search.data("options");
	var cache   = {};
	var $textSearchNonDomestic = $('.js-textSearchNonDomestic').val();
	var $textSearchProductLength = $('.js-textSearchProductLength').val();
	var $textSearchProductWidth = $('.js-textSearchProductWidth').val();
	var $textSearchShowAllResultsStart = $('.js-textSearchShowAllResultsStart').val();
	var $textSearchShowAllResultsEnd = $('.js-textSearchShowAllResultsEnd').val();
	var $isKmc = $('.js-isKmc').val();
	var $noPictureUrl = $('.js-noPictureSrc').val();
	var $stylingClasses;
	if ($isKmc == "true"){
		$stylingClasses = "ui-autocomplete-search-form ui-autocomplete-more-info";
	} else {
		$stylingClasses = "ui-autocomplete-search-form ui-autocomplete-less-info";
	}

	if (option)
	{
        $search.autocomplete({
            minLength: option.minCharactersBeforeRequest,
            delay:     option.waitTimeBeforeRequest,
            appendTo:  ".siteSearch",
            classes:   {
                "ui-autocomplete": $stylingClasses
            },
            source:    function(request, response) {

                var term = request.term.toLowerCase();

                if (term in cache) {
                    return response(cache[term]);
                }

                $.postJSON(option.autocompleteUrl, {term: request.term}, function(data) {
                    var autoSearchData = [];
                    if(data.suggestions != null){
                        $.each(data.suggestions, function (i, obj)
                        {
                            autoSearchData.push(
                                    {value: obj.term,
                                        url: ACC.autocomplete.searchUrl + "?text=" + obj.term,
                                        type: "autoSuggestion"});
                        });
                    }
                    if(data.products != null){
                        $.each(data.products, function (i, obj)
                        {
                            autoSearchData.push(
                                    {value: obj.masterProductname,
                                        code: obj.code,
                                        desc: obj.description,
                                        manufacturer: obj.manufacturer,
                                        url: ACC.autocomplete.searchResultBaseUrl + obj.url,
                                        type: "productResult",
                                        dimensionText: obj.dimensionText,
                                        gradeAndSurface: obj.gradeAndSurface,
                                        domestic: obj.domestic,
                                        lengthText: obj.lengthText,
                                        widthText: obj.widthText,
                                        weightText: obj.weightText,
                                        image: obj.images && obj.images[0] ? obj.images[0].url : ''});
                        });
                    }
                    if(data.totalResultsUrl != null && data.totalResultsCount != null && data.totalResultsCount > 0){
	                    autoSearchData.push(
	                            {value: "",
									count: data.totalResultsCount,
	                                url: data.totalResultsUrl,
	                                type: "totalResults"});
					}

                    cache[term] = autoSearchData;
                    return response(autoSearchData);
                });
            },
            focus: function (event, ui)
            {
                return false;
            },
            select: function (event, ui)
            {
                window.location.href = ui.item.url;
            }
        }).data('ui-autocomplete')._renderItem = function (ul, item)
        {
            if (item.type == "autoSuggestion")
            {
                var renderHtml = "<a href='" + ACC.autocomplete.searchUrl + "?query=" + item.value + "' class='clearfix'>";
                renderHtml += "<div class='suggestionWrapper'>"
                renderHtml += "<div class='icon-container'><i class='icon-search'></i></div>";
                renderHtml += "<div class='suggestion-container'><span>" + item.value + "</span></div>";
                renderHtml += "</div>" // close 'suggestionWrapper'
                renderHtml += "</a>"; // close the whole link
                return $("<li class='suggestions'>")
                        .data("item.autocomplete", item)
                        .append(renderHtml)
                        .appendTo(ul);
            }

            if (item.type == "productResult")
            {
				if ($isKmc == "true")
				{
					var renderHtml = "<a href='" + item.url + "' class='product'>";

					renderHtml += "<div class='productInfoWrapper'>"

	                if (option.displayProductImages)
	                {
						if (item.image) {
	                    	renderHtml += "<div class='thumb'><img src='" + item.image + "' /></div>";
						} else {
							renderHtml += "<div class='thumb'><img src='" + $noPictureUrl + "' /></div>";
						}
	                }
	                renderHtml += "<div class='desc'>";
	                renderHtml += "<div class='title'>" + item.value + "</div>";

	                renderHtml += "<div class='variantInfoWrapper'>"

	                renderHtml += "<div class='dimensionTextWrapper'>"
	                if (item.dimensionText)
	                {
						renderHtml += "<div>" + item.dimensionText + "</div>";
					}
					if (item.gradeAndSurface)
	                {
						renderHtml += "<div>" + item.gradeAndSurface + "</div>";
					}
					if (!item.domestic)
	                {
						renderHtml += "<div>" + $textSearchNonDomestic + "</div>";
					}
	                renderHtml += "</div>" // close 'dimensionTextWrapper'

	                renderHtml += "<div class='dimensionInfoWrapper'>"
	                if (item.lengthText)
	                {
						renderHtml += "<div>" + $textSearchProductLength + ":" + item.lengthText + "</div>";
					}
					if (item.widthText)
	                {
						renderHtml += "<div>" + $textSearchProductWidth + ":" + item.widthText + "</div>";
					}
					if (item.weightText)
	                {
						renderHtml += "<div>" + item.weightText + "</div>";
					}
	                renderHtml += "</div>" // close 'dimensionInfoWrapper'

	                renderHtml += "</div>" // close 'variantInfoWrapper'

	                renderHtml += "</div>" // close 'desc'
	                renderHtml += "</div>" // close 'productInfoWrapper'
                    renderHtml += "</a>"; // close the link 'product'
	                return $("<li class='product'>").data("item.autocomplete", item).append(renderHtml).appendTo(ul);

				} else
				{
	                var renderHtml = "<a href='" + item.url + "' class='product'>";
	                renderHtml += "<div class='productInfoWrapper'>"
	                if (option.displayProductImages)
	                {
						if (item.image) {
	                    	renderHtml += "<div class='thumb'><img src='" + item.image + "' /></div>";
						} else {
							renderHtml += "<div class='thumb'><img src='" + $noPictureUrl + "' /></div>";
						}
	                }
	                renderHtml += "<div class='desc'>";
	                renderHtml += "<div class='title'>" + item.value + "</div>";
	                renderHtml += "</div>" // close 'desc'
	                renderHtml += "</div>" // close 'productInfoWrapper'
                    renderHtml += "</a>"; // close the link 'product'
	                return $("<li class='product'>").data("item.autocomplete", item).append(renderHtml).appendTo(ul);
				}
            }

            if (item.type == "totalResults" && item.count > 0){
				var renderHtml = "<a href='" + item.url + "'><div class='allResultsLinkWrapper'>" + $textSearchShowAllResultsStart + item.count + $textSearchShowAllResultsEnd + "</div></a>";
				return $("<li class='totalResultsSection'>").data("item.autocomplete", item).append(renderHtml).appendTo(ul);
			}
        };
	}
};

ACC.autocomplete.bindMagnifyingGlass = function () {
    $(".icon-search").click(function () {
        $(this).closest('form').submit();
    })
}

$(document).ready(function () {
	ACC.autocomplete.bindAll();
});
